"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _streamChatReact = require("stream-chat-react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SearchResult = function SearchResult(_ref) {
  var result = _ref.result;
  var message = result.message;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-search__result-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "channel-search__result-day"
  }, (0, _momentTimezone.default)(message.created_at).format('MM/DD/YYYY')), /*#__PURE__*/_react.default.createElement(_streamChatReact.Message, {
    Message: _streamChatReact.MessageTeam,
    message: message
  }));
};
var _default = SearchResult;
exports.default = _default;